import { matchPath } from "react-router-dom";
import { IMMERSIVE_ROUTES, RESPONSIVE_ROUTES } from "../const/routesConst";

export const isResponsiveRoute = (pathname: string) => {
  return RESPONSIVE_ROUTES.some((route) =>
    matchPath({ path: route, end: true }, pathname)
  );
};

export const isImmersiveRoute = (pathname: string) => {
  return IMMERSIVE_ROUTES.some((route) =>
    matchPath({ path: route, end: true }, pathname)
  );
};
